package music.jammers.client.shared.component

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Shapes
import androidx.compose.material3.Typography
import androidx.compose.material3.darkColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.circe_bold
import limasoul.client.shared.generated.resources.circe_extra_bold
import limasoul.client.shared.generated.resources.circe_light
import limasoul.client.shared.generated.resources.circe_regular
import org.jetbrains.compose.resources.Font

private val darkScheme = darkColorScheme(
    primary = primaryDark,
    onPrimary = onPrimaryDark,
    primaryContainer = primaryContainerDark,
    onPrimaryContainer = onPrimaryContainerDark,
    secondary = secondaryDark,
    onSecondary = onSecondaryDark,
    secondaryContainer = secondaryContainerDark,
    onSecondaryContainer = onSecondaryContainerDark,
    tertiary = tertiaryDark,
    onTertiary = onTertiaryDark,
    tertiaryContainer = tertiaryContainerDark,
    onTertiaryContainer = onTertiaryContainerDark,
    error = errorDark,
    onError = onErrorDark,
    errorContainer = errorContainerDark,
    onErrorContainer = onErrorContainerDark,
    background = backgroundDark,
    onBackground = onBackgroundDark,
    surface = surfaceDark,
    onSurface = onSurfaceDark,
    surfaceVariant = surfaceVariantDark,
    onSurfaceVariant = onSurfaceVariantDark,
    outline = outlineDark,
    outlineVariant = outlineVariantDark,
    scrim = scrimDark,
    inverseSurface = inverseSurfaceDark,
    inverseOnSurface = inverseOnSurfaceDark,
    inversePrimary = inversePrimaryDark,
    surfaceDim = surfaceDimDark,
    surfaceBright = surfaceBrightDark,
    surfaceContainerLowest = surfaceContainerLowestDark,
    surfaceContainerLow = surfaceContainerLowDark,
    surfaceContainer = surfaceContainerDark,
    surfaceContainerHigh = surfaceContainerHighDark,
    surfaceContainerHighest = surfaceContainerHighestDark,
)

@Composable
fun TheJammersTheme(
    content: @Composable () -> Unit,
) {
    val shapes = Shapes(
        small = RoundedCornerShape(4.dp),
        medium = RoundedCornerShape(4.dp),
        large = RoundedCornerShape(0.dp)
    )

    val cicleFont = FontFamily(
        Font(Res.font.circe_regular),
        Font(Res.font.circe_bold, weight = FontWeight.Bold),
        Font(Res.font.circe_extra_bold, weight = FontWeight.ExtraBold),
        Font(Res.font.circe_light, weight = FontWeight.Light),
        Font(Res.font.circe_light, weight = FontWeight.ExtraLight),
    )

    val defaultTypography = Typography()
    val typography = defaultTypography.copy(
        displayLarge = defaultTypography.displayLarge.copy(fontFamily = cicleFont),
        displayMedium = defaultTypography.displayMedium.copy(fontFamily = cicleFont),
        displaySmall = defaultTypography.displaySmall.copy(fontFamily = cicleFont),
        headlineMedium = defaultTypography.headlineMedium.copy(
            fontFamily = cicleFont,
            fontWeight = FontWeight.Light,
            fontSize = 27.sp,
        ),
        headlineLarge = defaultTypography.headlineLarge.copy(
            fontFamily = cicleFont,
            fontWeight = FontWeight.Light,
            fontSize = 42.sp,
        ),
        headlineSmall = defaultTypography.headlineSmall.copy(fontFamily = cicleFont, fontWeight = FontWeight.Bold),
        titleMedium = defaultTypography.titleMedium.copy(fontFamily = cicleFont),
        titleLarge = defaultTypography.titleLarge.copy(fontFamily = cicleFont),
        titleSmall = defaultTypography.titleSmall.copy(fontFamily = cicleFont),
        bodyLarge = defaultTypography.bodyLarge.copy(fontFamily = cicleFont),
        bodyMedium = defaultTypography.bodyMedium.copy(fontFamily = cicleFont),
        bodySmall = defaultTypography.bodySmall.copy(fontFamily = cicleFont),
        labelLarge = defaultTypography.labelLarge.copy(fontFamily = cicleFont),
        labelMedium = defaultTypography.labelMedium.copy(fontFamily = cicleFont),
        labelSmall = defaultTypography.labelSmall.copy(fontFamily = cicleFont),
    )

    MaterialTheme(
        colorScheme = darkScheme,
        shapes = shapes,
        typography = typography,
        content = content
    )
}

expect val widthFraction: Float